import { userRoleFilterOption } from "../constants/TenantUserConstants";

// Get User Status Label
const getUserStatus = (user) => {
  if (user?.requiredActions?.length) {
    return "Angelegt";
  } else if (user?.enabled) {
    return "Aktiv";
  } else {
    return "Gesperrt";
  }
};

export const convertKeycloakObjectToClientObject = (user) => {
  Object.keys(user)?.forEach((item) => {
    if (item === "groups") {
      let previousGroups = [],
        previousSelectedGroups = [];

      user[item]?.forEach((roleDetails) => {
        if (roleDetails["path"].split("/")?.includes("Roles")) {
          const role = roleDetails["name"];

          user["roles"] =
            role + (user["roles"] !== undefined ? `, ${user["roles"]}` : "");

          previousSelectedGroups.push(roleDetails);
        }

        previousGroups.push(roleDetails);
      });
      user["previousGroups"] = previousGroups;
      user["previousSelectedGroups"] = previousSelectedGroups;
      user[item] = user["roles"];
    } else if (item === "enabled") {
      user[item] = getUserStatus(user);
    } else if (item === "empEmailId" && user[item]?.includes("api-user")) {
      //If its API user,then disabling the row
      user["disabledApiRole"] = true;
    } else {
      user[item] = user[item];
    }
  });
  return user;
};

export const isNotAdminAndAPIUserRoles = (roles) => {
  if (!roles || (Array.isArray(roles) && roles.length === 0)) return false;

  if (!Array.isArray(roles)) {
    roles = roles.split(",").map((item) => item.trim());
  }
  //  Filtering the data only for those which contains SUPPORT and APPROVER roles
  if (
    roles.includes(userRoleFilterOption.ADMIN) ||
    roles.includes(userRoleFilterOption.MDC_ADMIN) ||
    roles.includes(userRoleFilterOption.API_USER) ||
    roles.includes(userRoleFilterOption.EXPERT)
  ) {
    return false;
  }
  return true;
};

export const checkForTextEditorRegex = (content) => {
  if (!content) return null;

  const cleaned = content
    .replace(/<p>\s*(<br\s*\/?>)*\s*<\/p>/gi, "") // empty P
    .replace(/<br\s*\/?>/gi, "") // empty br
    .replace(/&nbsp;/g, "") // non-breaking spaces
    .replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, "") // P with only spaces, &nbsp; or br
    .trim();

  return cleaned ? content : null;
};
